import { render } from "./index.vue?vue&type=template&id=faaab546&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=faaab546&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faaab546"],['__file',"src/views/product/cartonSize/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "faaab546"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('faaab546', __exports__)) {
    api.reload('faaab546', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=faaab546&scoped=true", () => {
    api.rerender('faaab546', render)
  })

}


export default __exports__